import type { LoSiteBlock } from '@/lib/lyrraone-site-blocks';
import type { LoSiteElementStyle } from '@/lib/lyrraone-site-elements';
import { elementStyleClass, elementStyleToCss } from '@/lib/lyrraone-site-elements';
import { ThemeEditable } from '@/components/lyrraone/site-themes/LoSiteThemeEditable';
import { cn } from '@/lib/utils';

interface LoSiteThemedFaqProps {
  block: LoSiteBlock;
  blockKey: string;
  editMode?: boolean;
  selectedElementKey?: string | null;
  onSelectElement?: (key: string) => void;
  onInlineTextChange?: (key: string, value: string) => void;
  styleOf: (key: string) => LoSiteElementStyle | undefined;
}

export function LoSiteThemedFaq({
  block,
  blockKey,
  editMode,
  selectedElementKey,
  onSelectElement,
  onInlineTextChange,
  styleOf,
}: LoSiteThemedFaqProps) {
  const items = block.faqItems ?? [];

  return (
    <section key={blockKey} className="lo-section alt">
      <div className="lo-wrap">
        <div className="lo-section-head">
          {block.title && (
            <ThemeEditable
              elementKey="faq.title"
              editMode={editMode}
              selectedElementKey={selectedElementKey}
              onSelectElement={onSelectElement}
              onInlineTextChange={onInlineTextChange}
              className={cn('lo-h2', elementStyleClass(styleOf('faq.title')))}
              style={elementStyleToCss(styleOf('faq.title'))}
              as="h2"
              editableText
            >
              {block.title}
            </ThemeEditable>
          )}
        </div>
        <div className="lo-faq">
          {items.map((item, i) => {
            const qKey = `faq.item.${i}.question`;
            const aKey = `faq.item.${i}.answer`;
            return (
              <details key={i} className="lo-faq-item" open={editMode}>
                <summary>
                  <ThemeEditable
                    elementKey={qKey}
                    editMode={editMode}
                    selectedElementKey={selectedElementKey}
                    onSelectElement={onSelectElement}
                    onInlineTextChange={onInlineTextChange}
                    as="span"
                    editableText
                  >
                    {item.question}
                  </ThemeEditable>
                </summary>
                <ThemeEditable
                  elementKey={aKey}
                  editMode={editMode}
                  selectedElementKey={selectedElementKey}
                  onSelectElement={onSelectElement}
                  onInlineTextChange={onInlineTextChange}
                  as="p"
                  editableText
                >
                  {item.answer}
                </ThemeEditable>
              </details>
            );
          })}
        </div>
      </div>
    </section>
  );
}
